import React, {
	useCallback,
	useEffect,
	useState
} from 'react';
import PropTypes from 'prop-types';
import {
	Button,
	Grid,
	Icon,
	Input,
	List,
	Modal
} from 'semantic-ui-react';

import {
	useProgramAction,
	useProgramState
} from '../../../../../../contexts/ProgramsContext';

import styles from '../../programs.module.css';

const TemplateModuleFilterModal = ( { closeModal, open } ) => {
	const {
		templateModuleTags,
		templateModuleFilters
	} = useProgramState();
	const { setTemplateModuleFilters } = useProgramAction();

	const [ available, setAvailable ] = useState( [] );
	const [ selected, setSelected ] = useState( templateModuleFilters );
	const [ search, setSearch ] = useState( [] );

	useEffect( () => {
		const availableTags = templateModuleTags
			.filter( ( { id, text } ) => !selected.find( tag => tag.id === id )
				&& ( search.length
					? text.toLowerCase().includes( search.toLowerCase() )
					: true
				) );

		setAvailable( availableTags );
	}, [
		templateModuleTags,
		templateModuleFilters,
		search,
		selected
	] );

	const mapAvailable = useCallback( () => available.length
		? available.map( tag => {
			const select = () => {
				setSelected( prev => [ ...prev, tag ] );
			};

			return (
				<List.Item
					className={ styles.available }
					key={ tag.id }
					onClick={ select }
				>
					{ tag.text }
				</List.Item>
			);
		} )
		: <List.Item className={ styles.available }>No results found.</List.Item>, [ available ] );

	const mapSelected = useCallback( () => selected.map( tag => {
		const moduleTag = templateModuleTags.find( ( { id } ) => id === tag.id );

		const unselect = () => {
			setSelected( prev => prev.filter( p => p.id !== tag.id ) );
		};

		return <List.Item
			className={ styles.selected }
			key={ moduleTag.id }
		>
			{ moduleTag.text }
			<Icon
				className={ styles.unselect }
				link
				name="times"
				onClick={ unselect }
			/>
		</List.Item>;
	} ), [
		templateModuleTags,
		selected
	] );

	const handleCloseModal = useCallback( () => {
		closeModal();
	}, [ closeModal ] );

	const handleApplyFilters = useCallback( () => {
		setTemplateModuleFilters( selected );

		handleCloseModal();
	}, [
		handleCloseModal,
		selected,
		setTemplateModuleFilters
	] );

	const handleSearch = useCallback( ( e, { value } ) => {
		setSearch( value );
	}, [] );

	return (
		<>
			<Modal open={ open } size="tiny">
				<Modal.Header>Filter Template Modules By Tag</Modal.Header>
				<Modal.Content>
					<Grid stretched>
						<Grid.Row>
							<Grid.Column width={ 8 }>
								<h5 className={ styles.columnHeader }>Available Tags</h5>
								{ available.length || search
									? <>
										<Input
											className={ styles.availableSearch }
											fluid
											onChange={ handleSearch }
											icon="search"
											size="small"
											value={ search }
										/>
										<List className={ styles.availableList }>
											{ mapAvailable() }
										</List>
									</>
									: <p className={ styles.listEmptyMessage }>No available Tags.</p>
								}
							</Grid.Column>
							<Grid.Column width={ 8 }>
								<h5 className={ styles.columnHeader }>Selected Tags</h5>
								{ selected.length
									? <List className={ styles.selectedList }>
										{ mapSelected() }
									</List>
									: <p className={ styles.listEmptyMessage }>Please select a tag.</p>
								}
							</Grid.Column>
						</Grid.Row>
					</Grid>
				</Modal.Content>
				<Modal.Actions>
					<Button
						content="Apply"
						onClick={ handleApplyFilters }
					/>
					<Button
						content="Cancel"
						onClick={ handleCloseModal }
					/>
				</Modal.Actions>
			</Modal>
		</>
	);
};

TemplateModuleFilterModal.propTypes = {
	closeModal: PropTypes.func.isRequired,
	open: PropTypes.bool
};

export default TemplateModuleFilterModal;
